import { render, staticRenderFns } from "./start-page.vue?vue&type=template&id=69b9b2bc&scoped=true&"
import script from "./start-page.vue?vue&type=script&lang=js&"
export * from "./start-page.vue?vue&type=script&lang=js&"
import style0 from "./start-page.vue?vue&type=style&index=0&id=69b9b2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b9b2bc",
  null
  
)

export default component.exports